import React from "react";

import EventCalendar from "./EventCalendar";

import PageTitle from "../../layouts/PageTitle";

const Calendar = () => {
   return (
      <>
         <PageTitle activeMenu="PnL Calendar" motherMenu="App" />
         <h1>PnL Calendar</h1>

         <EventCalendar />
      </>
   );
};

export default Calendar;
